export default "__VITE_ASSET__BJfFzSPk__"